import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createNewss, getANews, resetState, updateANews } from "../features/news/newsSlice";
import { getCategories } from "../features/bcategory/bcategorySlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  content: yup.string().required("Description is Required"),
  categoryName: yup.string().required("Category is Required"),
  author: yup.string().required("Author is Required")
});

const AddNews = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const bCatState = useSelector((state) => state.bCategory.bCategories);
  const NewsState = useSelector((state) => state.news);
  const { isSuccess, isError, isLoading, createdNews, NewsName, NewsAuthor, NewsDesc, NewsCategory, updatedNews } = NewsState;
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState("");
  const [audio, setAudio] = useState(null);
  const [audioError, setAudioError] = useState("");

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getANews(getNewsId));
      dispatch(getCategories());
    } else {
      dispatch(resetState());
      dispatch(getCategories()); // Fetch categories only when component mounts
    }
  }, [getNewsId]);

  useEffect(() => {
    if (!getNewsId) {
      dispatch(getCategories()); // Fetch categories only when component mounts
    }
  }, []); // Empty dependency array to ensure it runs only once on mount

  useEffect(() => {
    dispatch(resetState());
  }, [dispatch]); // Reset state on component mount and whenever dispatch changes

  useEffect(() => {
    if (isError) {
      toast.error("Something Went Wrong!");
    } else {
      if (isSuccess && createdNews) {
        toast.success("News Added Successfully!");
        formik.resetForm(); // Reset the form after displaying success message
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
        setImage(null);
      }
      if (isSuccess && updatedNews) {
        toast.success("News Updated Successfully!");
        navigate("/admin/News-list");
        dispatch(resetState());
      }
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      author: NewsAuthor || "",
      title: NewsName || "",
      content: NewsDesc || "",
      categoryName: NewsCategory || "",
      image:"",
      audio:"",    
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (!image) {
        setImageError("Please select an image file.");
        return;
      } else {
        setImageError("");
      }
      if (!audio) {
        setImageError("Please select an Audio  file.");
        return;
      } else {
        setImageError("");
      }
      const formData = new FormData();
      formData.append("author", values.author);
      formData.append("title", values.title);
      formData.append("content", values.content);
      formData.append("categoryName", values.categoryName);
      formData.append("image", image);
      formData.append("audio", audio);

      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updateANews(data));
      } else {
        dispatch(createNewss(formData));
      }
    },
  });

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} News</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter News Author"
              name="author"
              onChng={formik.handleChange("author")}
              onBlr={formik.handleBlur("author")}
              val={formik.values.author}
            />
            <div className="error">{formik.touched.author && formik.errors.author}</div>
          </div>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter News Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
            <div className="error">{formik.touched.title && formik.errors.title}</div>
          </div> 
          <select
            name="categoryName"
            onChange={formik.handleChange("categoryName")}
            onBlur={formik.handleBlur("categoryName")}
            value={formik.values.categoryName}
            className="form-control py-3 mt-3"
          >
            <option value="">Select News Category</option>
            {bCatState.map((i, j) => (
              <option key={j} value={i.category_name}>
                {i.category_name}
              </option>
            ))}
          </select>
          <div className="error">{formik.touched.categoryName && formik.errors.categoryName}</div>
          <ReactQuill
            theme="snow"
            className="mt-3"
            name="content"
            modules={modules}
            onChange={formik.handleChange("content")}
            value={formik.values.content}
          />
          <div className="error">{formik.touched.content && formik.errors.content}</div>
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Image file
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                setImage(e.target.files[0] || null);
                setImageError(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{imageError}</div>
          </div>

          <div className="mt-4">
            <label htmlFor="audio" className="form-label">
              Select Audio File
            </label>
            <input
              type="file"
              id="audio"
              name="audio"
              accept="audio/*"
              onChange={(e) => {
                setAudio(e.target.files[0] || null);
                setAudioError(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{audioError}</div>
          </div>

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} News
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNews;
